"use client";

import { forwardRef, useState } from "react";
import { Input } from "@src/components/ui/input";
import { Button } from "@src/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@lib/utils/ui";
export type PasswordInputProps = React.InputHTMLAttributes<HTMLInputElement>;
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({
  className,
  placeholder = "••••••••••",
  ...props
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  return <div className="relative">
        <Input type={showPassword ? "text" : "password"} className={cn("pr-10", className)} placeholder={placeholder} ref={ref} {...props} />
        <Button type="button" variant="ghost" size="sm" className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent" onClick={() => setShowPassword(prev => !prev)} aria-label={showPassword ? "Hide password" : "Show password"}>
          {showPassword ? <EyeOff className="h-4 w-4 text-muted-foreground" /> : <Eye className="h-4 w-4 text-muted-foreground" />}
        </Button>
      </div>;
});
PasswordInput.displayName = "PasswordInput";